import { FC } from "react"
import Modal from "UI/Modal"
import styled from "styled-components"

const ModalBody = styled.div`
  padding: 24px;
  max-width: 600px;
`

type ExpenseType = keyof typeof expenseContent

const expenseContent = {
  csn_loan: {
    title: "Information om CSN-lån",
    content:
      "Här anger du ditt månatliga återbetalningsbelopp för CSN-lån. Detta inkluderar både studielån och eventuellt merkostnadslån.",
  },
  private_debt: {
    title: "Information om lån från privatpersoner",
    content:
      "Ange totalt månadsbelopp för lån du har från andra privatpersoner, inkluderar ränta, amortering, och avgifter.",
  },
  other_debt: {
    title: "Information om lån från andra bolag",
    content:
      "Ange totalt månadsbelopp, ränta, amortering, och avgifter inkluderade, för lån från andra finansiella aktörer än traditionella banker och kreditinstitut.",
  },
  private_leasing: {
    title: "Information om privatleasing",
    content:
      "Ange totalt månadsbelopp enligt leasingavtal. Detta ska inkludera alla fasta utgifter som är kopplade till leasingavtalet.",
  },
  guarantee_commitment: {
    title: "Information om borgensåtagande",
    content:
      "Ett borgensåtagande innebär att du går i borgen för någon annans lån. Ange det totala beloppet som du har gått i borgen för.",
  },
}

interface ExpenseInfoModalProps {
  expenseType: ExpenseType | null
  onClose: () => void
}

export const ExpenseInfoModal: FC<ExpenseInfoModalProps> = ({
  expenseType,
  onClose,
}) => {
  if (!expenseType) return null

  return (
    <Modal
      onClick={onClose}
      title={expenseContent[expenseType].title}
      body={<ModalBody>{expenseContent[expenseType].content}</ModalBody>}
    />
  )
}
